export default "This view offers a summary overview of the **Queues Report **, the data of the current day are always excluded. \n";